// src/utils/licenseUtils.js

function normalizeDate(d) {
  return new Date(d.getFullYear(), d.getMonth(), d.getDate());
}

/**
 * Paverčia license statusą į patogią struktūrą UI'ui.
 * @param {object|null} status { is_valid, valid_until, message, ... }
 * @returns { locked, diffDays, dateText, hasDate }
 */
export function getLicenseState(status) {
  if (!status) {
    return {
      locked: false,
      diffDays: null,
      dateText: null,
      hasDate: false,
    };
  }

  const { is_valid, valid_until } = status;

  // jei nėra datos – remiamės tik is_valid
  if (!valid_until) {
    return {
      locked: !is_valid,
      diffDays: null,
      dateText: null,
      hasDate: false,
    };
  }

  const expiresDate = new Date(valid_until);
  if (isNaN(expiresDate.getTime())) {
    // bloga data – geriau užrakinti jei is_valid = 0, bet diffDays nežinom
    return {
      locked: !is_valid,
      diffDays: null,
      dateText: null,
      hasDate: false,
    };
  }

  const today = normalizeDate(new Date());
  const expires = normalizeDate(expiresDate);
  const msPerDay = 1000 * 60 * 60 * 24;
  const diffDays = Math.round((expires - today) / msPerDay);
  const dateText = expires.toLocaleDateString("lt-LT");

  const locked = !is_valid || diffDays < 0;

  return {
    locked,
    diffDays,
    dateText,
    hasDate: true,
  };
}
